(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/add-tooltip-event.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/add-tooltip-event.js');
"use strict";

const VerifyType = svs.components.tbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.tbUtils.verify.verifyObject;
const BaseTooltipEvent = svs.components.onboarding.core.events.BaseTooltipEvent;
const TooltipEventType = svs.components.onboarding.core.events.constants.TooltipEventType;
class AddTooltipEvent extends BaseTooltipEvent {
  constructor(props) {
    verifyObject(props).schema({
      target: VerifyType.NotEmptyString,
      texts: [VerifyType.NotEmptyString],
      placement: VerifyType.NotEmptyString
    });
    super(TooltipEventType.Add, props);
  }
}

setGlobal('svs.components.onboarding.core.events.AddTooltipEvent', AddTooltipEvent);

 })(window);